The input parameter for the `updateUploadedCandidateProfilePositionPreferences` mutation.
